import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class ViewSwitch extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { className, style, views, selectedView, onChange, t } = this.props;

		return <ToggleButtonGroup className={className} style={style} type='radio' name='view' value={selectedView} onChange={onChange}>
			{views.map((x) => <ToggleButton key={x.name} value={x.name} className={selectedView === x.name ? 'btn-light-grey' : ''}>{x.label}</ToggleButton>)}
		</ToggleButtonGroup>;
	}
}

ViewSwitch.propTypes = {
	views: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		label: PropTypes.string
	})),
	selectedView: PropTypes.string,
	onChange: PropTypes.func
};

export default withTranslation()(ViewSwitch);